<template>
<div class="home">
    <!--img alt="Vue logo" src="../assets/logo.png"-->
    <div class="sticky-top"> <!-- 제일 위에 놓기 위함  -->
        <!-- <TopBar msg="이거슨 제일 위에에요" />
        <div class="container">
            <Summary msg="이거슨 Dashboard, Notification, Scripts, Statistics" />
        </div> -->
    </div>
    <div class="d-flex flex-row" style="background: white;">
        <div id="sidebar2" :class="showSidebar ? '' : 'hide'">
            <SideBar2 />
        </div>
        
        <div class="container-fluid" style="background: #f4f4f5; padding: 0">     
            <TopBar msg="이거슨 제일 위에에요" />
            <div style=" padding: 20px; background: #f4f4f5;">
                <Summary msg="이거슨 Dashboard, Notification, Scripts, Statistics" />
            
                <router-view @triggerProcessEvent="showProcess" @update="changeNotificationSelect"></router-view>
                <Footer msg="이그시 푸터" />
            </div>
        </div>
    </div>
    <!-- <div class="container">     
        <router-view @triggerProcessEvent="showProcess"></router-view>
        <Footer msg="이그시 푸터" />
    </div> -->

    <!--Detail modal start-->
    <b-modal size="xl" ref="modalProcess" header-class="detail-header" title="Process Details" ok-only ok-variant="secondary" ok-title="Close"> <!-- size = xl, lg, sm -->
    <loading :active.sync="detailProcessLoading" 
            :can-cancel="false" 
            :is-full-page="false"></loading>
        <h5>{{ peon(deviceId).alias }} {{ deviceId }}</h5> <br>
        <h5>{{ showProcessTitle() }} {{ action }} {{ startedTime }} ~ {{ finishedTime }}</h5>

        <b-form-textarea id="textarea" v-model="logFileContent" rows="25"></b-form-textarea>
        <b-form inline>
            <!--img src="../assets/images/filter.svg" alt="filter" class="filter-icon mr-2 ml-4"-->
            <label for="screenshot-list"  class=" mr-2 ml-2">Screenshots</label>
            <b-form-select id="screenshot-list" v-model="selectedScreenshot" :options="screenshotOptions" size="sm" class="mr-4"></b-form-select>
            <button type="button" class="ml-5 btn btn-blue btn-sm" @click="retrieveScreenshot(deviceId, selectedScreenshot)" :disabled="selectedScreenshot == ''">Load</button>
        </b-form>

        <b-img-lazy v-bind="screenProps" :src="screenshot" alt="Screenshot" class="screen"></b-img-lazy>

    </b-modal>
    <!--Detail modal end -->

    <b-modal id="homeMessageModal" header-class="fail-header" title="Message2" ok-only ok-variant="secondary" ok-title="Close">
        <p class="my-4 text-center">{{ msgContent }}</p>
    </b-modal>   
</div>
</template>

<script>
import UserService from '../services/user.service';

// @ is an alias to /src
import TopBar from '@/components/TopBar.vue'
import Summary from '@/components/Summary.vue'
import Footer from '@/components/Footer.vue'
import SideBar2 from "@/components/SideBar2.vue";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import SockJS from 'sockjs-client';
import Stomp from "stompjs";

export default {
    name: 'home',
    components: {
        TopBar,
        Summary,
        Footer,
        Loading,
        SideBar2
    },
    data() {
        return {
            deviceId: null,
            uuid: null,

            // command / sendLogFile 의 결과에서 받아오는 것들
            logFile: null,  // log file의 이름
            screenshots: [],  // screenshot들.. 있으면.. 없으면 []

            process: '',  // 프로세스, 그냥 실행이면 ''
            version: '',  // 버전, 이것도 그냥 실행이면 ''
            script: '',  // 스크립트 파일, 그냥 실행이면 전체 경로, 프로세스 실행이면 starting point

            action: '',  // started / finished
            startedTime: '',  // 시작 시간
            finishedTime: '',  // 종료 시간 (아직 종료 전이면 '')

            type: '',  // Manual or CronTab
            schedule: '',  // CronTab 일 때만 내용 있음

            logFileContent: '',  // 로그 파일의 내용 (text)

            selectedScreenshot: '',

            screenshot: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
            screenProps: {
                center: true,
                fluidGrow: true,
                blank: true,
                blankColor: '#bbb',
                width: 600,
                height: 400,
                class: 'my-5'
            },

            msgStatus: '',  // alert popup 의 status 인데 사용하진 않고, 아래 content는 보여줌
            msgContent: '',
            detailProcessLoading: false,
            showSidebar: true,
            socket: null,

            selectedPeon: '', // Notification에서 설정된 필터값
            selectedLevel: '',
            selectedGroup: '',
            selectedFrom: '',
            selectedTo: '',
            
        }
    },
    computed: {
        peon() {
            return function(deviceId) {
                if (deviceId == null) {
                    return {};
                }

                var peon = this.$store.getters.getPeon(deviceId);

                return peon;
            }
        },
        screenshotOptions() {
            var options = null;
            if (this.screenshots.length == 0) {
                options = [
                    { value: '', text: '스크린샷 없음' }
                ];
            } else {
                options = [
                    { value: '', text: '보고 싶은 스크린샷을 선택하세요.' }
                ];

                this.screenshots.forEach((item) => {
                    options.push({ value: item, text: item });
                });
            }

            return options;
        }
    },
    methods: {
        changeNotificationSelect({ property, value }) {
            // notification.vue에서 선택된 조건
            this[property] = value;
        },
        // 웹소켓 연결
        async openWebSocket() {
            if (this.stompClient && this.stompClient.connected) {
                return;
            }
            this.socket = new SockJS(WORKMAN_URL + "peon", {transports: ['websocket']});
            
            this.stompClient = Stomp.over(this.socket);
            this.stompClient.debug = null;
            await this.stompClient.connect({ Authorization: accessToken()}, () => {
                // 1. Dashboard heartbeat정보 받아서 update하기 기존: retrieveLatestData
                this.stompClient.subscribe('/update/peonStatus', (message)=>{
                    let peonStatus = JSON.parse(message.body);
                    let peon = this.$store.getters.getPeonList.map(item => {
                        if (item.deviceId === peonStatus.deviceId) {
                            return {
                                ...item,
                                status: peonStatus.status,
                                tenantId: peonStatus.tenantId,
                                deviceId: peonStatus.deviceId
                            };
                        }
                        return item;
                    }).filter(item => item.deviceId === peonStatus.deviceId);
                    
                    this.$store.commit('updatePeonStatus', peon);
                });

                // 2. notification 정보 받기
                this.stompClient.subscribe('/insert/notification', (message)=>{
                    // peon에서 받은 데이터 update : 선택된 조건이 빈값이거나 일치할 경우에만 insert
                    let peonNotification = JSON.parse(message.body);
                    const findAlias = this.$store.state.peonList.find(item => item.deviceId === peonNotification.deviceId);
                    peonNotification.alias = findAlias ? findAlias.alias : '';
                    
                    let groupList = [];
                    this.$store.state.peonList2.forEach((item) => {
                        if(this.selectedGroup === '' || item.deviceGroupId === this.selectedGroup){
                            groupList.push(item);
                        }
                    });

                    const isLevelMatch = this.selectedLevel === '' || this.selectedLevel === peonNotification.level;
                    const isGroupMatch = groupList.some(item => item.deviceId === peonNotification.deviceId);
                    const isPeonMatch = this.selectedPeon === '' || this.selectedPeon === peonNotification.deviceId;
                    const isFromMatch = this.selectedFrom === '' || this.selectedFrom <= peonNotification.timestamp;
                    const isToMatch = this.selectedTo === '' || (this.selectedTo + ' 23:59:59') >= peonNotification.timestamp;
                    
                    if (isLevelMatch && isPeonMatch && isGroupMatch && isFromMatch && isToMatch) {
                        this.$store.commit('insertNotification', peonNotification);
                        if(peonNotification.level !== 'normal') this.$store.commit('incrementTotalUnconfirmedAlarm');
                    }
                    
                });
            });
        },
        showProcess(deviceId, uuid) {
            this.clearVariables();

            if (deviceId == null || uuid == null) {
                this.showMessage(null, 'deviceId(' + deviceId + ') 와 uuid(' + uuid + ') 가 있어야 합니다.');

                return;
            }

            this.deviceId = deviceId;
            this.uuid = uuid;

            // 버전 확인해서 2.1.0 미만이면 문구 던지고 보여줄 것 대폭 감소..
            // 모든 row에서 해당 문구가 발생해서 일단 주석..
            // if (this.$store.getters.isPeonLaterThan(deviceId, '2.1.0') === false) {
            //     this.showMessage(null, "설치된 버전이 2.1.0 미만입니다. 업데이트를 해주세요.");

            //     return;
            // }

            this.requestLogFile(deviceId, uuid);

        },
        showMessage(status, message) {
            this.msgStatus = status;
            this.msgContent = message;
            
            this.$bvModal.show('homeMessageModal');
        },
        clearVariables() {
            this.deviceId = null;
            this.uuid = null;

            this.logFile = null,  // log file의 이름
            this.screenshots = [],  // screenshot들.. 있으면.. 없으면 []

            this.process = '',  // 프로세스, 그냥 실행이면 ''
            this.version = '',  // 버전, 이것도 그냥 실행이면 ''
            this.script = '',  // 스크립트 파일, 그냥 실행이면 전체 경로, 프로세스 실행이면 starting point

            this.action = '',  // started / finished
            this.startedTime = '',  // 시작 시간
            this.finishedTime = '',  // 종료 시간 (아직 종료 전이면 '')

            this.type = '',  // Manual or CronTab
            this.schedule = '',  // CronTab 일 때만 내용 있음

            this.logFileContent = '',  // 로그 파일의 내용 (text)

            this.selectedScreenshot = '',

            this.screenshot = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",

            this.msgStatus = '',  // alert popup 의 status 인데 사용하진 않고, 아래 content는 보여줌
            this.msgContent = '',
            this.detailProcessLoading = false
        },
        showProcessTitle() {
            if (this.process == '') {
                return this.script;
            } else {
                return this.process + ' : ' + this.version + ' (' + this.script + ')';
            }
        },
        // peon에게 uuid에 해당하는 스크립트 실행 시 발생한 로그 및 스크린샷(파일 이름 only)의 정보를 보내달라고 요청
        // peon은 전달 받으면 로그 및 해당 정보를 업로드
        requestLogFile(deviceId, uuid) {
            this.detailProcessLoading = true;

            var params = {
                'command': 'sendLogFile',
                'deviceId': deviceId,
                'uuid': uuid
            };

            axios.post('peon/command', params, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                if(response.data.status != 200 && response.data.status != 0) {
                    this.showMessage(null, response.data.message);
                } else {
                    this.logFile = response.data.body.logFile;
                    this.screenshots = response.data.body.screenshots;
    
                    this.process = response.data.body.process;
                    this.version = response.data.body.version;
                    this.script = response.data.body.script;
    
                    this.action = response.data.body.action;
                    this.startedTime = response.data.body.startedTime;
                    this.finishedTime = response.data.body.finishedTime;
    
                    this.type = response.data.body.type;
                    this.schedule = response.data.body.schedule;
                    if (this.logFile != null && this.logFile.length > 0) {
                        this.retrieveLogFile(deviceId, this.logFile);
                    }
                    this.$refs['modalProcess'].show();
                }
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.detailProcessLoading = false;
            });
        },
        retrieveLogFile(deviceId, logFile) {
            this.detailProcessLoading = true;

            var params = {
                'deviceId': deviceId,
                'logFile': logFile
            };

            axios({
                method: 'get',
                url: 'peon/retrieveLogFile',
                params: params,
                responseType: 'blob',
                headers: {
                    'Content-type': 'plain/text',
                    'Authorization': accessToken()
                }
            }).then(response => {

                // this.logFileContent = response.data;

                let reader = new FileReader();
                reader.readAsText(response.data); 
                reader.onload = () => {
                    this.logFileContent = reader.result;
                }
            }).catch(error => {
                if (error.status != 401) {
                    // this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                    // 여긴 blob 이라 그냥 내 맘대로 메시지를 보여줌
                    this.showMessage(error.status, logFile + " 파일을 찾을 수 없습니다.");
                }
            }).finally(() => {
                this.detailProcessLoading = false;
            });
        },
        retrieveScreenshot(deviceId, screenshot) {
            this.detailProcessLoading = true;

            var params = {
                'deviceId': deviceId,
                'screenshot': screenshot,
                'reload': true
            };

            axios({
                method: 'get',
                url: 'peon/retrieveScreenshot',
                params: params,
                responseType: 'blob',
                headers: {
                    'Content-type': 'image/png',
                    'Authorization': accessToken()
                }
            }).then(response => {
                let reader = new FileReader();
                reader.readAsDataURL(response.data); 
                reader.onload = () => {
                    this.screenshot = reader.result;
                }
            }).catch(error => {
                if (error.status != 401) {
                    // this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                    // 여긴 blob 이라 그냥 내 맘대로 메시지를 보여줌
                    this.showMessage(error.status, this.screenshotInfo[this.selectedMonitor].screenshot + " 파일을 찾을 수 없습니다.");
                }
            }).finally(() => {
                this.detailProcessLoading = false;
            });
        },
        toggleSidebar() {
            this.showSidebar = !this.showSidebar;
        },
        retrievePeonList() {
            return axios
            .get(
                WORKMAN_URL +
                "device/retrieveDeviceList?pageSize=100&sort=alias&groupId=''"
                ,
                {
                headers: {
                    Accept: "application/json",
                    Authorization: accessToken(),
                },
                }
            )
            .then(response => {
                response.data.body.list.forEach(item => {
                    this.$store.state.peonList2.push(item);
                });
            });
        },
        retrieveGroupList() {
            axios.get('device/retrieveGroupListByUser', {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then((response) => {
                var options = [{value: '', text: '전체'}];
                response.data.body.list.forEach((group) => {
                    options.push({
                        value: group.groupId, text: group.groupId
                    });
                });

                this.$store.commit('setGroupOptions', options);
            });
        },
    },
    mounted() {
        this.openWebSocket();
    },
    created() {
        this.retrievePeonList();
        this.retrieveGroupList();
    },
    destroyed() {
        if (this.stompClient && this.stompClient.connected) {
            this.stompClient.unsubscribe('/insert/notification'); // 구독 해제
            this.stompClient.disconnect(); // STOMP 클라이언트 연결 종료
        }
        if (this.socket) {
            this.socket.close();
        }
    },
}
</script>
